module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"giftCard":"GIFT CARD","giftCardMobile":"Gift Card"},"th":{"giftCard":"บัตรของขวัญ","giftCardMobile":"บัตรของขวัญ"}}')
  delete Component.options._Ctor
}
